/* eslint-disable jsx-a11y/anchor-is-valid */

// @ts-nocheck
import React, {useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Dropdown1} from '../../../../_metronic/partials'
import {useLocation, useParams} from 'react-router'
// import {
//   useActivateOrDeactivateSubAdminMutation,
//   useGetSubAdminByIdQuery,
// } from '../../../../../api'
import clsx from 'clsx'

// @ts-ignore
const SubAdminDetailsHeader: React.FC<{data: any}> = ({data}) => {
  const {id} = useParams()

  // const {data, isLoading, error} = useGetSubAdminByIdQuery(id)

  const location = useLocation()
  // const [activate, setActivate] = useState(data?.status)
  const [activate, setActivate] = useState(false)
  const [showModal, setShowModal] = useState(false)

  console.log(id, 'id')
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              {/* <img src={toAbsoluteUrl('/media/avatars/300-1.jpg')} alt='Metronic' /> */}
              <div
                className={clsx(
                  'symbol-label fs-5tx',
                  `bg-light-${data?.name[0]}`,
                  `text-${data?.name[0]}`
                )}
              >
                {/* {user.initials?.label} */}
                {data?.name[0]}
              </div>
              {/* <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div> */}
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                    {data?.name}
                  </a>
                  <a href='#'>
                    {/* <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-1 svg-icon-primary'
                    /> */}
                  </a>
                  {/* <a
                    href='#'
                    className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_upgrade_plan'
                  >
                    Upgrade to Pro
                  </a> */}
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com006.svg'
                      className='svg-icon-4 me-1'
                    />
                    {data?.role?.isAdmin ? 'Admin' : 'Sub Admin'}
                  </a>
                  {/* <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen018.svg'
                      className='svg-icon-4 me-1'
                    />
                    New York
                  </a> */}
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {data?.email}
                  </a>

                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {data?.phone}
                  </a>
                </div>
              </div>

              {/* New Modal Begins */}

              {/* Toggle Button Begins */}
              <div className=''>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    // value=''
                    id='flexSwitchDefault'
                    onChange={() => setShowModal(true)}
                    checked={Boolean(data?.status)}
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                  />
                  <label
                    htmlFor='flexSwitchDefault'
                    style={{fontWeight: 'bold', margin: '4px 8px'}}
                    className='btn'
                  >
                    {data?.status ? 'Activated' : 'Deactivated'}
                  </label>
                </div>
              </div>
              {/* Toggle Button Ends */}

              {/* New Modal Ends */}
              {showModal && (
                <MessageModal
                  data={data}
                  id={id}
                  showModal={showModal}
                  setShowModal={setShowModal}
                  activate={activate}
                  setActivate={setActivate}
                  message={'error'}
                  error={error}
                />
              )}
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === `/apps/user-management/users/details-page/overview${id}` &&
                    'active')
                }
                to='overview'
              >
                Overview
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/apps/user-management/users/details-page/setting' &&
                    'active')
                }
                to='setting'
              >
                Settings
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

//@ts-ignore
const MessageModal = ({
  id,
  data,
  showModal,
  setShowModal,
  message,
  error,
  activate,
  setActivate,
}) => {
  const [activateOrDeactivateSubAdmin, res] = useActivateOrDeactivateSubAdminMutation()
  console.log(id)
  console.log('response', res?.data)

  return (
    <>
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'> {data?.status ? 'Deactivate' : 'Activate'}</h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={() => setShowModal(false)}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>
                <div className='modal-body fs-3'>
                  <p>
                    {data.status
                      ? 'Are you sure you want to deactivate this Sub Admin ?'
                      : 'Are you sure you want to activate this Sub Admin ?'}
                  </p>
                </div>
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => setShowModal(false)}
                    data-bs-dismiss='modal'
                  >
                    No
                  </button>
                  <button
                    onClick={async () => {
                      console.log(id)
                      // @ts-ignore
                      await activateOrDeactivateSubAdmin({user_id: id})
                        .unwrap()
                        .then((user) => {
                          setActivate(user.status)
                          setShowModal(false)
                        })
                        .catch((err) => console.log('error', err))
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

export default SubAdminDetailsHeader
